module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel4-fr-FR-abeba47ad1345386fba6c8b040009102.png";